import axios from 'axios';
import { CommissionGroup } from '../../features/commissionGroups/commissionGroupSlice';
import apiRequestHeaders from '../apiRequestHeaders';
import { CommissionGroupDetails } from '../../features/commissionGroups/commissionGroupDetailsSlice';

const commissionGroupsService = {
  fetchCommissionGroups: async (siteId: string): Promise<CommissionGroup[]> => {
    const params = { siteId };
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params,
    };

    const response = await axios.get<CommissionGroup[]>(
      `/accommodation/commissiongroups/getCommissionGroups`,
      config,
    );
    return response.data;
  },
  fetchCommissionGroupDetails: async (commissionGroupId: string) => {
    const params = { commissionGroupId };
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params,
    };

    const response = await axios.get<CommissionGroupDetails>(
      `/accommodation/commissiongroups/getDetails`,
      config,
    );
    return response.data;
  },
  saveOrUpdateCommissionGroup: async (
    commissionData: CommissionGroupDetails,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/accommodation/commissiongroups/saveOrUpdate',
      commissionData,
      config,
    );
    return response.data;
  },
};

export default commissionGroupsService;
